@if(content?.trustpilotMiniTemplateId && content.trustpilotBusinessunitId){
@if(sku(); as sku){
<div (click)="onClick()">
    <trustpilot-widget [templateId]="content.trustpilotMiniTemplateId || ''"
                       [businessunitId]="content.trustpilotBusinessunitId || ''"
                       [locale]="'en-US'"
                       [styleHeight]="'24px'"
                       [styleWidth]="'100%'"
                       [theme]="'light'"
                       [starColor]="'#fdb714'"
                       [sku]="sku || ''"
                       [name]="product().data?.name || ''"
                       [styleAlignment]="'left'"
                       [noReviews]="'collapse'"
                       [reviewLanguages]="'en'"
                       [availability]="product().trustpilotAvailability || ''"
                       [price]="product().price" />
</div>
}
}
